<div provideParentForm class="position-relative">
  <input style="line-height: 1.5 !important;" class="form-control hijriInput"
         [(ngModel)]="selectedDate"
         [placeholder]="placeHolder ?placeHolder : 'd/m/yyyy'"
         ngbDatepicker
         (click)="d.toggle()"
         (dateSelect)="changeDate()"
         #d="ngbDatepicker"
         [readonly]="readonly"
         [minDate]="min"
         [maxDate]="max"
         [required]="isRequired"
         [name]="name"
         (blur)="onBlur()"
             (keypress)="$event.preventDefault()"
         [disabled]="disabled" />
  <!--<i class="icon-calendar d-inline-block position-absolute __calendar-icon" (click)="onBlur()"></i>-->
</div>
